import { MainSt, ArticleSt } from "./styled";

import Button from "./Button";
interface ArticleProps {
  title: string;
  active: string;
  buttons: any;
  selectRisk: any;
}
export default function Risks({
  title,
  active,
  selectRisk,
  buttons,
}: ArticleProps) {
  return (
    <ArticleSt>
      <h2>{title}</h2>
      <MainSt>
        {buttons.map((b: string) => (
          <Button
            width="100px"
            height="60px"
            size="12px"
            active={active}
            func={selectRisk}
            key={b}
          >
            {b}
          </Button>
        ))}
      </MainSt>
    </ArticleSt>
  );
}
